module.exports = __webpack_public_path__ + "b53ea92d0bbf02b2370ab86cbda897aa.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/badge.png
// module id = 682
// module chunks = 0